import { useCallback, useMemo } from "react";
import { Button, Space, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useAppContext, useDashboardLayoutsContext, useDashboardPanelContext } from "@data-root/react";
import { GroupButton } from "@/views/DashboardView/components/group-button";
import { AddParamButton } from "@/views/DashboardView/components/add-param-button";
import { ParamButton } from "@/views/DashboardView/components/param-button";

const { Text } = Typography;

export const PanelHeader = () => {
  const { deleteLayout } = useDashboardLayoutsContext();
  const { layout, params } = useDashboardPanelContext();

  const { getView } = useAppContext();

  const view = useMemo(() => getView(layout.viewId), [layout.viewId, getView]);

  const onClickClose = useCallback(() => {
    deleteLayout(layout.id);
  }, [deleteLayout, layout.id]);

  return (
    <Space
      style={{
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Space>
        <Text strong>{view.name}</Text>

        <GroupButton />

        <Space>
          {params.map((param, i) => (
            <ParamButton key={i} param={param} />
          ))}

          <AddParamButton />
        </Space>
      </Space>

      <Space.Compact>
        <Button
          type="link"
          style={{ color: "black" }}
          size="small"
          icon={<CloseOutlined />}
          onClick={onClickClose}
        />
      </Space.Compact>
    </Space>
  );
};
